(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
   
$(document).ready(function(){
       $(".popup img").click( function () {
         // debugger;
        var $src = $(this).attr("src");
      $('html').addClass('popup_class_cust');
        $(".show").fadeIn();        
        $(".img-show img").attr("src", $src);
    }); 
         $("span, .overlay").click(function () {
            $('html').removeClass('popup_class_cust');
        $(".show").fadeOut();
    }); 
});
  

  } catch(e) { console.error(e); }
})();
})();
